import { notification } from 'antd'
import store from '@app-store/store'
import { rootActions } from '@app-store/slices'
import { prepareDownloadAndSendQuery } from '@features/Meeting/MeetingAgenda'

export const onDownload = (companyId, pureFilters) => {
    const payload: any = {
        ...prepareDownloadAndSendQuery(companyId, pureFilters || {}),
        sagaCB: {
            onSuccess: result => {
                const blob = new Blob([result], { type: 'application/pdf' })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `MeetingAgenda-${+new Date()}.pdf`
                link.click()
            }
        }
    }
    store.dispatch(rootActions.reporting.downloadAgendas.onRequest(payload))
}

export const onSend = (companyId, pureFilters, cb = () => undefined) => {
    const payload: any = {
        ...prepareDownloadAndSendQuery(companyId, pureFilters || {}),
        sagaCB: {
            onSuccess: () => {
                cb()
                notification.success({
                    message: 'Meeting agenda sent successfully.'
                })
            }
        }
    }
    store.dispatch(rootActions.reporting.sendAgendas.onRequest(payload))
}
